/* Scroll affordances for the Sütible rail.

   THE RAIL IS STILL A SCROLLER. The arrows drive the same native scroll that a
   trackpad, a swipe, a keyboard or a screen reader already drives - they set
   scrollLeft and nothing else. That is why there is no index to keep in sync, no
   autoplay timer, and nothing to go wrong if the script never loads: without it
   the row still scrolls, it just has no buttons and no fades. Scroll snapping
   does the landing, so a click always finishes on a card edge.

   THE STEP IS MEASURED, NOT ASSUMED. Card width is a clamp() that changes with
   the viewport and the gap is set in CSS, so both are read back at click time
   rather than hardcoded here.

   STATE DRIVES BOTH SIDES. Each side's arrow and its edge fade appear only when
   there is actually something that way, so the right-hand pair is visible on
   arrival - the whole point, since nothing else says the row moves - and the
   left-hand pair stays out of the way until it means something. ResizeObserver
   covers the window resizing and images settling after first paint, both of
   which change scrollWidth. */
(function () {
  var init = function (root) {
    if (!root || root.dataset.sutReady === '1') return;
    var rail = root.querySelector('.sut__rail');
    var wrap = root.querySelector('.sut__railwrap');
    if (!rail || !wrap) return;
    root.dataset.sutReady = '1';

    var btns = Array.prototype.slice.call(wrap.querySelectorAll('.sut__arrow'));
    var raf = 0;

    var step = function () {
      var item = rail.querySelector('.sut__item');
      if (!item) return rail.clientWidth;
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 18;
      return item.getBoundingClientRect().width + gap;
    };

    var sync = function () {
      var max = rail.scrollWidth - rail.clientWidth;
      var x = rail.scrollLeft;
      var scrollable = max > 2;
      var more = { left: scrollable && x > 2, right: scrollable && x < max - 2 };
      wrap.classList.toggle('is-more-left', more.left);
      wrap.classList.toggle('is-more-right', more.right);
      btns.forEach(function (b) {
        var dir = Number(b.getAttribute('data-dir'));
        b.disabled = dir < 0 ? !more.left : !more.right;
      });
    };

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        rail.scrollBy({ left: Number(b.getAttribute('data-dir')) * step(), behavior: 'smooth' });
      });
    });

    rail.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    if (window.ResizeObserver) new ResizeObserver(sync).observe(rail);
    else window.addEventListener('resize', sync);

    sync();
  };

  var boot = function () {
    Array.prototype.forEach.call(document.querySelectorAll('.sut'), init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor: a section re-render replaces the markup, so the flag goes with it. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('.sut'));
  });
})();
